module.exports = __webpack_public_path__ + "static/media/yoshimasa_suzuki.4fa83c48.jpg";